import { isNil } from 'lodash'
import { modifyPrivacyLocal } from '@/utils/privacy-state'

/**
 * Axios 响应头隐私状态同步插件
 *
 * 从响应头 sensitive-state 字段读取隐私开关状态并同步到本地。
 * 需要在主 response 拦截器之前执行（主拦截器只返回 body，会丢失 headers）。
 */
export default function privacyPlugin(axiosInstance) {
  const index = axiosInstance.interceptors.response.use((response) => {
    const sensitive = response.headers['sensitive-state']
    if (!isNil(sensitive)) {
      modifyPrivacyLocal(sensitive)
    }
    return response
  })

  // 主拦截器只返回 body 会丢失 headers，所以隐私拦截器必须排在最前
  const { handlers } = axiosInstance.interceptors.response
  handlers.unshift(handlers.splice(index, 1)[0])
}
